import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import { TableCell } from "@mui/material";
import { useState } from "react";
import BoxEditIco from "../../../assets/icons/BoxEditIco";
import DeleteIco from "../../../assets/icons/DeleteIco";
import CustomMenuItem from "../../../component/Menu";
import CommonTable from "../../candidates/Table";
import AddGroupPermission from "./AddGroupPermission";

export default function Group() {
  const [selectedRows, setSelectedRows] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClickDot = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //   const handleMenuClose = () => {
  //     setAnchorEl(null);
  //   };

  const menuData = [
    {
      title: "Edit Group",
      image: <BoxEditIco />,
      onClick: () => {
        setOpenDialog(true);
      },
    },
    { title: "Delete Group", image: <DeleteIco /> },
  ];

  const sortedData = [
    { group: "Admin", people: "1", date: "Oct 10, 2024" },
    { group: "Manager", people: "1", date: "Oct 10, 2024" },
    { group: "Recruiter", people: "1", date: "Oct 10, 2024" },
  ];
  const headerData = [
    { name: "Group" },
    { name: "People" },
    { name: "Creation Date" },
    "",
  ];

  const handleRowCheckboxChange = (row) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(row.group)) {
        return prevSelectedRows.filter((group) => group !== row.group);
      } else {
        return [...prevSelectedRows, row.group];
      }
    });
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleTableBodyData = (row) => {
    return (
      <>
        <TableCell>{row.group}</TableCell>

        <TableCell>{row.people}</TableCell>

        <TableCell>{row.date}</TableCell>

        <TableCell width={"2%"} aria-haspopup="true">
          <MoreVertOutlinedIcon
            style={{ cursor: "pointer" }}
            onClick={(event) => handleClickDot(event)}
          />
        </TableCell>
      </>
    );
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <CommonTable
        data={sortedData}
        marginTop={"2rem"}
        columns={headerData}
        onRowCheckboxChange={handleRowCheckboxChange}
        handleTableBodyData={handleTableBodyData}
      />
      <CustomMenuItem
        open={open}
        anchorEl={anchorEl}
        handleMenuClose={handleMenuClose}
        menuData={menuData}
      />

      <AddGroupPermission
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        isEdit={true}
      />
    </>
  );
}
